/* ============================== I C O N S ============================== */

import iconTimes from '@/components/Icons/Times/Times.vue';
import iconExclamTrian from '@/components/Icons/ExclamTrian/ExclamTrian.vue';
import iconCheckCircle from '@/components/Icons/CheckCircle/CheckCircle.vue';
import iconInfoCircle from '@/components/Icons/InfoCircle/InfoCircle.vue';


/* ============================= E X P O R T ============================= */

export default {
  name: 'Alert',

  props: {
    label: String,

    type: {
      type: String,
      in: [
        'danger',
        'warning',
        'success',
        'info'
      ]
    }
  },

  components: {
    iconTimes,
    iconExclamTrian,
    iconCheckCircle,
    iconInfoCircle
  }
}
